import React, { FC, useEffect, useState, memo, useMemo } from 'react';
import { OnChangeOptionsType, TablePropsOptionsType, TableRowType, TableSimplePropsType } from 'src/types/table';
import Table from '../Table';
import { filterRows, sortRows } from './functions';

const TableSimple: FC<TableSimplePropsType> = (props) => {
    const sessionOptions = props.optionsSessionName
        ? JSON.parse(sessionStorage.getItem(props.optionsSessionName) || 'null')
        : null;

    const [tableOptions, setTableOptions] = useState<TablePropsOptionsType>(
        sessionOptions || {
            filters: props.initFilters || [],
            sort: props.initSort,
            page: 1,
            items: props.defaultItems || 20,
            columns: [...props.allColumns.map((column) => column)],
        }
    );
    const [renderRows, setRenderRows] = useState<TableRowType[]>([]);
    const [rowIdKey, setRowIdKey] = useState<string>(props.rowIdKey);
    const [options, setOptions] = useState<TablePropsOptionsType>(tableOptions);
    // Optimalizované sortování pomocí useMemo
    const sortedRows = useMemo(() => {
        return sortRows(props.rows, tableOptions.sort, props.allColumns);
    }, [props.rows, tableOptions.sort, props.allColumns]);

    // Optimalizované filtrování pomocí useMemo
    const filteredRows = useMemo(() => {
        return filterRows(sortedRows, [...(tableOptions.filters || [])], props.allColumns, props.customFilter);
    }, [sortedRows, tableOptions.filters, props.allColumns, props.customFilter]);
    useEffect(() => {
        setOptions({ ...tableOptions, totalCount: filteredRows?.length });
    }, [tableOptions, filteredRows, props.rows]);

    const indexFrom = (tableOptions.page - 1) * tableOptions.items;
    const indexTo = indexFrom + tableOptions.items;

    useEffect(() => {
        setRenderRows(filteredRows.slice(indexFrom, indexTo));
        setRowIdKey(props.rowIdKey);
    }, [filteredRows, indexFrom, indexTo]);

    const handleChangeOptions: OnChangeOptionsType = (newOptions) => {
        setTableOptions(newOptions);
        if (props.onChangeOptions) {
            props.onChangeOptions(newOptions);
        }
    };

    return (
        <Table
            allColumns={props.allColumns}
            ref={props.tableRef}
            rowIdKey={rowIdKey}
            selectRowIdKey={props.selectRowIdKey}
            rows={renderRows}
            allFilteredRows={props.allFilteredRows || filteredRows}
            loading={props.loading}
            columsLabelPrefix={props.columsLabelPrefix}
            options={options}
            onChangeOptions={handleChangeOptions}
            rowActions={props.rowActions}
            selectOptions={props.selectOptions}
            disableFilter={props.disableFilter}
            customRow={props.customRow}
            customRowActions={props.customRowActions}
            selectedRows={props.selectedRows}
            setSelectedRows={props.setSelectedRows}
            customRender={props.customRender}
            sx={props.sx}
            rowSxFce={props.rowSxFce}
            maxHeight={props.maxHeight}
            heightVariant={props.heightVariant}
            fullHeight={props.fullHeight}
            optionsSessionName={props.optionsSessionName}
            userSettingsName={props.userSettingsName}
            userSettingsData={props.userSettingsData}
            editUserSettings={props.editUserSettings}
            sumCols={props.sumCols}
            showInModal={props.showInModal}
            sumColsFilter={props.sumColsFilter}
            customRowRender={props.customRowRender}
            optionStyleFce={props.optionStyleFce}
            footerLeft={props.footerLeft}
            dataTestId={props.dataTestId}
        />
    );
};

export default memo(TableSimple);
